import { ENV_CROPS_MAX_DIGITS_AFTER_DECIMAL, ENV_CROPS_MAX_UNIT_PRICE } from 'appConstants';
import { type IValidationField } from 'hooks/useValidations/types';
import { t } from 'i18next';
import * as yup from 'yup';

export default function envCropsUnitPrice({ label = '', context = {} }: IValidationField) {
  const {
    min = 0,
    max = ENV_CROPS_MAX_UNIT_PRICE,
    required = true,
  } = context as {
    min?: number;
    max?: number;
    required?: boolean;
  };

  let validation = yup
    .number()
    .label(label)
    .typeError(`${label} ${t('errors.number')}`)
    .transform((value) => (isNaN(value) ? undefined : value))
    .moreThan(min)
    .lessThan(max)
    .test(
      'maxDigitsAfterDecimal',
      t('errors.maxDigitsAfterDecimal', { label, count: ENV_CROPS_MAX_DIGITS_AFTER_DECIMAL }),
      (value) =>
        value == null
          ? true
          : new RegExp(`^\\d+(\\.\\d{1,${ENV_CROPS_MAX_DIGITS_AFTER_DECIMAL}})?$`).test(
              value.toString(),
            ),
    )
    .nullable();

  if (required) validation = validation.required();

  return validation;
}
